import { array, boolean, date, mixed, object, ref, string } from "yup";

let addCalendarEventDefaultValues: any = {
  type: "TASK",
  task: null,
  title: "",
  location: "",
  date: null,
  startTime: null,
  endTime: null,
  reminderCheck: false,
  reminder: "",
  notes: "",
};

let AddCalendarEventSchema = () => {
  return object()
    .nullable()
    .shape({
      type: string().required(),
      task: object()
        .nullable()
        .when("type", {
          is: "TASK",
          then: (schema) => schema.required("Task is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
      title: string()
        .required("Event name is required")
        .min(3, "Event name should be atleast 3 characters"),
      location: string().required("Location is required"),
      date: date().nullable().typeError("Invalid date").required("Date is required"),
      startTime: date()
        .nullable()
        .typeError("Invalid start time")
        .required("Start time is required"),
      endTime: date()
        .nullable()
        .min(ref("startTime"), "End time should be greater than start time")
        .typeError("Invalid end time")
        .required("End time is required"),
      notes: string().notRequired(),
      reminderCheck: boolean().notRequired(),
      reminder: mixed().when("reminderCheck", {
        is: (reminderCheck: boolean) => reminderCheck,
        then: string().required("Reminder is required"),
        otherwise: string().notRequired(),
      }),
    });
};

export { addCalendarEventDefaultValues, AddCalendarEventSchema };
